import React, { FC } from 'react';

import { theme } from '../../../../global';
import BasicTimer from '../Basic';
import { BasicCommandType } from '../config';

const TimerRedCommand: FC<BasicCommandType> = (props) => (
  <BasicTimer
    {...props}
    $inactive_color={theme.colors.inactive_red}
    $active_color={theme.colors.active_red}
  />
);

export default TimerRedCommand;
